import React, { useState, useEffect } from "react";
import _ from "lodash";
import styled from "styled-components";
import { useStaticQuery, graphql } from "gatsby";
import { globalHistory } from "@reach/router";

import Margin from "./layouts/Margin";
import Text from "./Text";
import B from "./Button";
import Close from "../../images/icons/x-button-white.svg";
import theme from "../../styles/theme";

const {
	colors,
	breakPoints: { mobileFirstScreenQuery },
} = theme;

const Wrapper = styled.div`
	width: 100%;
	display: block;
	height: ${(props) => (props.open ? "fit-content" : "0px")};
	background-color: ${(props) =>
		props.color === "orange" ? colors.brandMain : colors.secondary.dark};
	z-index: 8;
	position: relative;

	${mobileFirstScreenQuery.medium} {
		height: ${(props) => (props.open ? "70px" : "0px")};
	}
`;
const Bar = styled(Margin)`
	display: flex;
	flex-wrap: nowrap;
	justify-content: center;
	align-items: center;
	padding: 8px 10px;

	p {
		margin: 0 15px 0 0;
		justify-self: center;
		height: 100%;
		color: ${colors.white};
		font-size: 14px;
	}

	${mobileFirstScreenQuery.medium} {
		padding: 15px;

		p {
			font-size: 16px;

		}
	}
`;

const Button = styled(B)`
	color: ${(props) => (props.color === "orange" ? colors.brandMain : colors.secondary.dark)};
	background: ${colors.white};
	font-weight: 600;
	font-size: 1.1em;
	text-transform: uppercase;
	white-space: nowrap;
	letter-spacing: 2px;
	padding: 10px 15px;
	margin-right: 15px;

	:hover {
		color: ${colors.white};
		background: ${(props) => (props.color === "orange" ? colors.brandMain : colors.secondary.dark)};
	}

	${mobileFirstScreenQuery.medium} {
		border: 1px solid ${colors.white};
		margin-right: 15px;
		font-size: 1.3em;

		border-radius: 30px;
		a {
			margin-top: 15px;
		}
	}
`;

const CloseButton = styled.img`
	transition-duration: 0.75s;
	width: 23px;
	position: absolute;
	right: 15px;
	top: 50%;
    transform: translateY(-50%);
}
	:hover {
		cursor: pointer;
	}
`;

const AnnouncementBar = ({ text, buttonText, buttonLink, color, ...props }) => {
	return (
		<Bar id="announcement-bar" open={props.open}>
			<Text component="b3">
				{text}
			</Text>
			<Button color={color} className="announcement-bar-button" link={buttonLink}>
				{buttonText}
			</Button>
		</Bar>
	);
};

export default () => {
	const data = useStaticQuery(graphql`
		query AnnouncementBarQuery {
			announcementBar: contentfulAnnouncementBar(contentful_id: { eq: "5FQFLBXVrDmYi2CcoOloQ" }) {
				isActive
				staticDisplay
				color
				currentAnnouncement {
					announcementButtonLink
					announcementButtonText
					announcementMainText
				}
			}
		}
	`);

	const { isActive, staticDisplay, color, currentAnnouncement } = data.announcementBar;

	// Contentful uses a boolean, true is orange, false is blue
	const currentColor = color ? "orange" : "blue";
	const [open, setOpen] = useState(false);

	useEffect(() => {
		if (
			// Check if it is the page for the annoucment, is a help link, or if the close_annoucement cookie was set
			location.href === currentAnnouncement.announcementButtonLink ||
			location.href.indexOf("/help") > 0 ||
			sessionStorage.getItem("close_annoucement") === "true"
		) {
			setOpen(false);
		} else if (isActive) {
			setOpen(true);
		}

		globalHistory.listen(({ action }) => {
			if (action === "PUSH" && staticDisplay === false) {
				sessionStorage.setItem("close_annoucement", "true");
			}
		});
	}, []);

	return (
		open && (
			<Wrapper open={open} color={currentColor}>
				<AnnouncementBar
					buttonText={currentAnnouncement.announcementButtonText}
					buttonLink={currentAnnouncement.announcementButtonLink}
					text={currentAnnouncement.announcementMainText}
					open={open}
					color={currentColor}
					setOpen={setOpen}
				/>
				<CloseButton
					className="close-button"
					src={Close}
					onClick={() => {
						setOpen(!open);
						sessionStorage.setItem("close_annoucement", "true");
					}}
				/>
			</Wrapper>
		)
	);
};
